import React from 'react';
import { createRoot } from 'react-dom/client';
// LicenseInfo via the declared dependency: @mui/x-license-pro is only a transitive one.
import { LicenseInfo } from '@mui/x-data-grid-pro';
import { installChunkReloadHandler } from './Lib/chunkReload';
import App from './Application/App';

if (import.meta.env.VITE_MUI_X_LICENSE != null && import.meta.env.VITE_MUI_X_LICENSE !== '') {
    LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE);
}

// After a deploy, a tab on the old build reloads onto the new one instead of 404ing on a chunk.
installChunkReloadHandler();

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
